import { axiosInstance } from '../client';
import { BASE_API_URL } from 'src/app/environment';

export interface ImageQuotaStatus {
  used: number;
  limit: number | 'unlimited';
  remaining: number | 'unlimited';
}

export const getImageQuotaStatus = async (
  locationKey: string,
  userId: string,
  tier?: string,
  cycleStart?: string,
  cycleDays?: number,
): Promise<ImageQuotaStatus> => {
  const url = `${BASE_API_URL}/ai/usage/image`;
  const { data } = await axiosInstance.get(url, {
    params: { lid: locationKey, uid: userId, tier, cycleStart, cycleDays },
  });
  if (!data?.success) {
    throw new Error('Failed to fetch image quota status');
  }
  if (data.limit === Infinity) {
    return { used: 0, limit: 'unlimited', remaining: 'unlimited' };
  }
  return {
    used: typeof data.used === 'number' ? data.used : 0,
    limit: typeof data.limit === 'number' ? data.limit : 30,
    remaining:
      typeof data.remaining === 'number'
        ? data.remaining
        : Math.max(
            0,
            (typeof data.limit === 'number' ? data.limit : 30) -
              (typeof data.used === 'number' ? data.used : 0),
          ),
  };
};
